import React from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import Modal, { IModalChildProps } from '../../common/modal';
import '../../my-account/order-details/modals/modal-styles.css';

const Under18Modal = ({ onAccept, onClose }: IModalChildProps) => {
    const intl = useIntl();

    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        id="closeModalCableLengthModal"
                        data-dismiss="modal"
                        aria-label={intl.formatMessage({
                            id: 'Close',
                        })}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <p className="text-center modal-spacing">
                    <FormattedMessage
                        id="43080_1DT_ID"
                        defaultMessage="The Starlink Charger (not the Mini Premium) is recommended with the length 4 or 5 receiver to allow for space for the length of the cable."
                    />
                </p>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        <FormattedMessage id="Close" defaultMessage="Close" />
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default Under18Modal;
